export const prodConfig = {
  apiKey: "AIzaSyA6pp7D6kyTDBIdTNJO6MS3BNMxElHsO34",
  authDomain: "cyno-telephysio-pilot.firebaseapp.com",
  databaseURL: "https://cyno-telephysio-pilot.firebaseio.com",
  projectId: "cyno-telephysio-pilot",
  storageBucket: "cyno-telephysio-pilot.appspot.com",
  messagingSenderId: "605660991085"
};

export const stagConfig = {
    apiKey: "AIzaSyAKQm6E1Bl1jUgQkqj7DpTvhCuLnaKXdjI",
    authDomain: "cyno-corporate-test.firebaseapp.com",
    databaseURL: "https://cyno-corporate-test.firebaseio.com",
    projectId: "cyno-corporate-test",
    storageBucket: "cyno-corporate-test.appspot.com",
    messagingSenderId: "563026325924"
}


// WEBPACK FOOTER //
// ./src/js/firebase/config.js